<template>
    <aside class="right-aside">
        <!-- Content Header (Page header) -->
        <section class="content-header ">
            <h1 v-html="uLang('app.' + this.$route.meta.title)">Title</h1>
        </section>
        <!-- Main content -->
        <section class="content">
            <slot></slot>
        </section>

        <div class="copyright mt-3 mb-2">
            <div class="container">
                <div class="col-md-12 text-center">
                    <small>
                        In het kader van onze dienstverlening verwerken wij persoonsgegevens. In onze
                        <a style="color: #cc0072;"
                           href="https://docs.google.com/document/d/178n5ygn9G7nR10qK5emtuBPMWKf56OypCzPpdrewyGY"
                           target="_blank">
                            privacyverklaring
                        </a>
                        informeren wij u over hoe wij met persoonsgegevens omgaan.
                    </small>

                    <br>

                    <small>
                        Voor onze klachtenprocedure verwijzen wij u naar ons
                        <a style="color: #cc0072;"
                           href="https://docs.google.com/document/d/1-YPylVOYXQpVK5ShWUfC1g3ITt98RiB2fwaj-Y0IqAs"
                           target="_blank">
                            klachtenregelement
                        </a>.
                    </small>

                    <br>
                    <br>

                    <small>Realisatie: <a href="https://webgatosoftware.com/" target="_blank">Webgato Software</a></small>
                </div>
            </div>
        </div>
        <feedback-form v-if="$can('create-feedback')"></feedback-form>
    </aside>
</template>
<script>
import {FeedbackForm} from '~/components/elements'

export default {
    name: "right-side",

    components: {
        FeedbackForm,
    }
}
</script>
<style lang="scss" scoped>
.content {
    padding: 2rem;
}

.right-aside {
    padding: 0 20px 10px 20px;
    width: 100%;
    max-width: 100%;

    .content-header > h1 {
        margin: 2px;
        padding-left: 13px;
        padding-top: 12px;
        font-size: 20px;
        line-height: 1.5;
    }

    .content-header {
        /* margin: -2px -20px 25px -20px; */
        height: 55px;
        background: #f9fafb;
        box-shadow: 3px 1px 5px #ccc;
    }
}
</style>
